export const CONTENT_TYPES = {
    INSIGHT: "insight",
    QUERY: "query",
    TEAM: "team",
    IPLRESULT: "iplresult",
};
